export default "__VITE_ASSET__ButP7Fy1__"